import { calculateYearsOfPractice } from "../../utils/date.utils";
import { firstLetterCapitalizeWords } from '../../utils/regex.utils';

export const modifyInfoData = (data: any) => {
    let personalInfo: any[] = []
    let professionalInfo: any[] = []

    if (data) {
        const primaryPhone = data?.phones?.find((phone: any) => phone?.isPrimary)?.number
        personalInfo = [
            { itemTitle: "First Name", itemContent: data?.firstName ?? "--" },
            { itemTitle: "Last Name", itemContent: data?.lastName ?? "--" },
            { itemTitle: "Email Address", itemContent: data?.emails?.find((email: any) => email?.isPrimary)?.email ?? "--" },
            { itemTitle: "Phone Number", itemContent:  primaryPhone ? primaryPhone :  "--" }
        ];
        const practiceYear = data?.specialties?.find((val: any) => val?.type)?.year ?? 0
        const practiceMonth = data?.specialties?.find((val: any) => val?.type)?.month ?? 0
        const totalPracticeYears = calculateYearsOfPractice(practiceYear, practiceMonth)

        professionalInfo = [
            { itemTitle: "Primary Specialty", itemContent: data?.specialties?.find((val: any) => val?.type)?.name ?? "--" },
            { itemTitle: "National Provider Identifier (NPI)", itemContent: data?.npi ?? "--" },
            { itemTitle: "Years of Practice in Specialty", itemContent: totalPracticeYears ?? "--" },
            { itemTitle: "Preferred Communication", itemContent: firstLetterCapitalizeWords(data?.prefCommMethod) ?? "--" }
        ];
    }
    return { personalInfo, professionalInfo }
}

export const modifyPracticeInfoData = (practice_data: any) => {
    let practice_info: any[] = []
    if (practice_data) {
        const addressLine1 = practice_data?.address?.street1 ?? "--"
        const addressLine2 = practice_data?.address?.street2 ?? "--"
        const addressLine3 = `${practice_data?.address?.city ?? "--"}, ${practice_data?.address?.state ?? "--"} ${practice_data?.address?.zip ?? "--"}`

        practice_info = [
            { itemTitle: "Organization Name", itemContent: practice_data?.orgName ?? "--" },
            { itemTitle: "Practice Type", itemContent: practice_data?.type ? practice_data?.type : "--" },
            { itemTitle: "Organization Address", itemContent: addressLine1 + " " + addressLine2, itemSubContent: addressLine3 },
        ];
    }
    return practice_info
}